import React, { useEffect, useState, useCallback } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { paymentService } from '../services/paymentService';

const PaymentSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [sessionData, setSessionData] = useState<any>(null);

  const verifyPayment = useCallback(async (sessionId: string) => {
    try {
      console.log('[支付验证] 开始验证session:', sessionId);
      const session = await paymentService.getSessionStatus(sessionId);
      console.log('[支付验证] 获取到session数据:', session);
      setSessionData(session);
      
      if (session.payment_status === 'complete' || session.payment_status === 'paid') {
        // 支付成功，保存订单信息到localStorage
        const customerEmail = session.customer_details?.email || session.customer_email || '';
        const orderInfo = {
          orderId: session.id, // 这里保存的是session ID，不是真正的订单ID
          customerEmail: customerEmail,
          productId: session.metadata?.product_id,
          paymentStatus: session.payment_status,
          sessionId: sessionId,
          verified: true // 标记为已验证
        };
        localStorage.setItem('last_order', JSON.stringify(orderInfo));
        
                 // 跳转到产品详情页面
         const productId = session.metadata?.product_id;
         if (productId) {
           setTimeout(() => {
             navigate(`/product/${productId}`);
           }, 3000); // 3秒后自动跳转
         }
      } else {
        setError('支付未完成');
      }
    } catch (err) {
      console.error('Payment verification error:', err);
      
      // 即使API调用失败，也尝试从URL参数获取产品信息
      const sessionId = searchParams.get('session_id');
             if (sessionId) {
         console.log('[支付验证] API调用失败，但session_id存在，准备跳转');
         // 显示友好的错误信息，但自动跳转
         setError('支付处理中，正在为您跳转...');
         setTimeout(() => {
           console.log('[支付验证] 跳转到产品详情页面');
           // 尝试从URL中提取产品ID，或者跳转到产品列表
           const urlParams = new URLSearchParams(window.location.search);
           const productId = urlParams.get('product_id') || sessionId.split('_')[2]; // 从session_id中提取
           if (productId) {
             navigate(`/product/${productId}`);
           } else {
             navigate('/products');
           }
         }, 2000);
       } else {
        console.error('[支付验证] 缺少session_id参数');
        setError('验证支付状态失败');
      }
    } finally {
      setLoading(false);
    }
  }, [navigate, searchParams]);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (sessionId) {
      verifyPayment(sessionId);
    } else {
      setError('缺少支付会话信息');
      setLoading(false);
    }
  }, [searchParams, verifyPayment]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500 mx-auto mb-4"></div>
          <p className="text-gray-600">正在验证支付状态...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">支付处理中</h2>
          <p className="text-gray-600 mb-4">您的支付可能已经成功，正在处理订单...</p>
          <p className="text-gray-500 mb-6 text-sm">3秒后自动跳转到产品列表，您可以查看购买状态</p>
          <button
            onClick={() => navigate('/products')}
            className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg"
          >
            立即查看产品
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        {/* 成功图标 */}
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        {/* 成功标题 */}
        <h1 className="text-2xl font-bold text-gray-900 mb-2">支付成功！</h1>
        <p className="text-gray-600 mb-6">感谢您的购买，正在为您准备下载...</p>

        {/* 支付信息 */}
        {sessionData && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <div className="text-sm text-gray-600 space-y-2">
                             <div className="flex justify-between">
                 <span>支付金额:</span>
                 <span className="font-semibold">¥{(sessionData.amount_total / 100).toFixed(2)}</span>
               </div>
              <div className="flex justify-between">
                <span>订单状态:</span>
                <span className="text-green-600 font-semibold">已完成</span>
              </div>
            </div>
          </div>
        )}

                 {/* 自动跳转提示 */}
         <div className="text-sm text-gray-500 mb-6">
           <p>页面将在 3 秒后自动跳转到产品详情页面</p>
         </div>

        {/* 操作按钮 */}
        <div className="space-y-3">
          <button
            onClick={() => navigate('/products')}
            className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200"
          >
            继续购物
          </button>
                     <button
             onClick={() => {
               const productId = sessionData?.metadata?.product_id;
               if (productId) {
                 navigate(`/product/${productId}`);
               } else {
                 navigate('/products');
               }
             }}
             className="w-full bg-gray-500 hover:bg-gray-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200"
           >
             查看产品详情
           </button>
        </div>

        {/* 联系信息 */}
        <div className="mt-6 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-500">
            如有问题，请联系客服: support@strengthstudio.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess; 